import {Signal} from "../../fjsc/src/signals.ts";
import {FJSC} from "../../fjsc";
import {InputType} from "../../fjsc/src/Types.ts";

export class Inputs {
    static text(value: Signal<string>, label: string, name: string) {
        return FJSC.input<string>({
            type: InputType.text,
            name,
            label,
            value,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                value.value = v;
            }
        });
    }

    static longtext(value: Signal<string>, label: string, name: string) {
        return FJSC.textarea({
            name,
            label,
            value,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                value.value = v;
            }
        });
    }

    static date(value: Signal<string>, label: string, name: string) {
        return FJSC.input<string>({
            type: InputType.date,
            name,
            label,
            value,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                value.value = v;
            }
        });
    }

    static number(value: Signal<number>, label: string, name: string) {
        return FJSC.input<number>({
            type: InputType.number,
            name,
            label,
            value,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                value.value = v;
            }
        });
    }

    static url(link: Signal<any>, label: string, name: string) {
        return FJSC.input<string>({
            type: InputType.url,
            name,
            label,
            value: link,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                link.value = v;
            }
        });
    }

    static email(email: Signal<any>, label: string, name: string) {
        return FJSC.input<string>({
            type: InputType.email,
            name,
            label,
            value: email,
            attributes: ["autocomplete", name],
            onchange: (v) => {
                email.value = v;
            }
        });
    }
}
